import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=7b668c05&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b668c05",
  null
  
)

export default component.exports